import { Application } from "merchant-api/types";
import { PricingRequest } from "./getPricingDetails";

export function toPricingRequest(selectedOffer, applicationData: Application, customerData): PricingRequest {
    return {
        applicationType: applicationData?.type,
        applicationId: applicationData?.id,
        customerData: {
            businessCountry: customerData?.businessCountry,
            businessState: customerData?.businessState,
            legalEntity: customerData?.legalEntity,
        },
        loanSpecifics: [
            {
                centsOnDollar: selectedOffer?.pricedDetails.trueCentsOnDollar,
                collectionType: "ACH",
                line: selectedOffer?.pricedDetails.lineAmount,
                oFeePercentage: selectedOffer?.originationFeePct,
                paymentFrequency: selectedOffer?.pricedDetails.paymentFrequency,
                product: "TermLoan",
                productType: "TermLoan",
                term: selectedOffer?.pricedDetails.term,
            },
        ],
    };
}
